import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PrivateLayout from '../layouts/PrivateLayout';
import { connect } from 'react-redux';
import { OPS_ADMIN, UiRoutes } from '../lib/constants';
import { getDefaultPathFromMerchant } from '../lib/helper';
import RedirectToLogin from './RedirectToLogin';

const AdminLoginPrivateRoute: FC<{
  component: FC;
  path: string;
  exact?: boolean;
  loginState;
  roleState;
  isAdmin: boolean;
}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { path, exact, ...rest } = props;
  const Component = props.component;

  const opsRoutes = [
    UiRoutes.OPS_IMEI_BULK_UPLOAD_HISTORY,
    UiRoutes.OPS_IMEI_BULK_UPLOAD_HISTORY_IMEI,
    UiRoutes.OPS_REFUNDS_BULK_UPLOAD_HISTORY,
    UiRoutes.OPS_REFUNDS_BULK_UPLOAD_HISTORY_REFUND,
    UiRoutes.ADMIN_USER_MANAGEMENT,
  ];

  const { isUserAuthenticated, isWaitingForAPIResponse, mappedProducts } =
    props.loginState;

  const adminDefaultRoute = getDefaultPathFromMerchant(mappedProducts);

  return !isWaitingForAPIResponse ? (
    isUserAuthenticated ? (
      props?.roleState?.roleName === OPS_ADMIN && !opsRoutes.includes(path) ? (
        <Redirect to={UiRoutes.OPS_REFUNDS_BULK_UPLOAD_HISTORY} />
      ) :
        (props.isAdmin && props.loginState?.isPartnerMerchant && props.loginState.MerchantId) ?
          <Redirect to={UiRoutes.PARTNER_SUMMARY} />
          :
          (props.isAdmin && props.loginState.MerchantId) || !props.isAdmin ? (
            <Redirect to={adminDefaultRoute} />
          ) : (
        <Route
          path={path}
          exact={exact}
          render={(renderProps) => (
            <PrivateLayout>
              <Component {...renderProps} />
            </PrivateLayout>
          )}
        />
      )
    ) : (
      <RedirectToLogin />
    )
  ) : (
    <React.Fragment></React.Fragment>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  roleState: loginReducer.roleState,
  isAdmin: loginReducer.loginState.isAdmin,
});

export default connect(mapStateToProps)(AdminLoginPrivateRoute);
